export const apiScopes = {
	default: '.default',
	favorites: {
		user_impersonation: 'https://mytakeda.onmicrosoft.com/favoritesapi/user_impersonation',
	},
	graph: {
		group_read_all: 'https://graph.microsoft.com/Group.Read.All',
	},
	marketplace: {
		user_impersonation: 'https://mytakeda.onmicrosoft.com/marketplaceapi/user_impersonation',
	},
	orgExplorer: {
		user_impersonation: 'https://mytakeda.onmicrosoft.com/orgexplorerapi/user_impersonation',
	},
	procurement: {
		user_impersonation: 'https://mytakeda.onmicrosoft.com/procurementapi/user_impersonation',
	},
};
